module.exports = __webpack_public_path__ + "static/media/Data_insight_mo_2-2.52d91591.svg";